<script lang="ts">
    import {dayOptimisationOverviewMockData, generateMockDonutData} from './mock-data';
    import KpDonutChart from 'shared/components/kp-charts/KpDonutChart.svelte';
    import DayOverviewJobTypeSummaryCard from '../../details-tab/reported-work/DayOverviewJobTypeSummaryCard.svelte';
    import OptimisationOverviewContainer from './components/OptimisationOverviewContainer.svelte';
    import OptimisationOverviewHeading from './components/OptimisationOverviewHeading.svelte';
</script>

<OptimisationOverviewContainer>
    <OptimisationOverviewHeading heading="Denní přehled" printButtonLabel="Tisk montážního deníku"/>

    <div class="job-type-summaries-container">
        {#each dayOptimisationOverviewMockData.jobTypeSummaries as jobTypeSummary}
            <DayOverviewJobTypeSummaryCard {jobTypeSummary}/>
        {/each}
    </div>

    <div class="donut-chart-container">
        <KpDonutChart size="250px" data="{generateMockDonutData()}" let:showedValue>
            <span class="chart-value">{showedValue}</span>
            <span class="chart-label">hodin</span>
        </KpDonutChart>
    </div>
</OptimisationOverviewContainer>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .job-type-summaries-container {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: @spacing-xl;
    }

    .donut-chart-container {
        .chart-value {
            font-size: @font-size-xxl;
            font-weight: 500;
        }

        .chart-label {
            color: @themed-text-muted;
        }
    }
</style>